import { render, staticRenderFns } from "./FeedbackChannel.vue?vue&type=template&id=42a819be"
import script from "./FeedbackChannel.vue?vue&type=script&lang=js"
export * from "./FeedbackChannel.vue?vue&type=script&lang=js"
import style0 from "./FeedbackChannel.vue?vue&type=style&index=0&id=42a819be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports